import { Icon, Paper, makeStyles } from "@material-ui/core";
import { WarningRounded } from "@material-ui/icons";
import React from "react";

const useStyles = makeStyles(() => ({
    container: {
        alignSelf: "stretch",
        padding: "12px 16px",
        minWidth: "400px",
        display: "flex",
        gap: "12px",
        alignItems: "center",
        backgroundColor: "#fffbeb",
        border: "1px solid #fde68a",
        borderRadius: "10px",
        boxShadow: "0 1px 3px rgba(245, 158, 11, 0.12)",
    },
    message: {
        margin: 0,
        fontSize: "14px",
        fontWeight: 500,
        color: "#92400e",
    },
}));

interface Props {
    message: string;
}

export function Banner({ message }: Props) {
    const classes = useStyles();
    return (
        <Paper className={classes.container} elevation={0}>
            <Icon>
                <WarningRounded />
            </Icon>
            <div>
                <p className={classes.message}>
                    {message}
                </p>
            </div>
        </Paper>
    );
}